import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiErrorHandler } from '../../../errors/api-error-handler';
import { RightSideTrailType, RightSideTrailInitialStateType } from "../../../models/right-side-trail-model";
import NewsArticlesRightSideRelatedEventsService from '../../../services/right-side/news-articles-right-side-related-events.service';

const initialState: RightSideTrailInitialStateType = {
    rightSideFeaturedBooksData: [],
    rightSideFeaturedLearningData: [],
    rightSideTrendingNewsData: [],
    rightSidePopularEventsData: [],
    Loading: false,
    Error: undefined,
};

export const retrieveNewsArticlesRightSideRelatedEvents = createAsyncThunk('NewsArticlesRightSideRelatedEvents/retrieve',
    async (productPath: string, { rejectWithValue }) => {
        try {

            const response = await NewsArticlesRightSideRelatedEventsService.getNewsArticlesRightSideRelatedEventsService(productPath)
            return [response.data]

        } catch (error: any) {
            if (!error.response) {
                throw error
            }
            return rejectWithValue(error.response.status)
        }
    }
)

const NewsArticlesRightSideRelatedEventsSlice = createSlice({
    name: 'NewsArticlesRightSideRelatedEvents',
    initialState: initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(retrieveNewsArticlesRightSideRelatedEvents.pending, (state) => {
                state.Loading = true;
            })
            .addCase(retrieveNewsArticlesRightSideRelatedEvents.fulfilled, (state, action) => {
                if (action.payload) {
                    state.Loading = false;
                    state.rightSidePopularEventsData = action.payload as RightSideTrailType[];
                }
            })
            .addCase(retrieveNewsArticlesRightSideRelatedEvents.rejected, (state, { payload }) => {
                state.Loading = false;
                state.Error = apiErrorHandler(Number(payload))
            })
    }
})

export const selectAllEntities = (state: { entities: any; }) => state.entities;
export default NewsArticlesRightSideRelatedEventsSlice.reducer;
